module.exports = __webpack_public_path__ + "img/9791186294055.df39a790.jpg";